import {
    Alert,
    Collapse,
    FormControlLabel,
    FormGroup,
    Switch,
    TextField,
} from '@mui/material'
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { useState } from 'react'
import { dropStartDateValid } from '../editor/DropCreatorUtils'
import { DropPaper } from '../drops/DropPaper'
import { useTranslation } from 'react-i18next'

export const AirdropSnapshotEditor = ({ snapshotDate, setSnapshotDate }) => {
    const [use24hrFormat, setUse24hrFormat] = useState(false)

    const { t } = useTranslation('common')

    return (
        <DropPaper
            id={'AirDropStartEndDateEditor'}
            title={t('airdrops.snapshot_time')}
            error={!dropStartDateValid(true, snapshotDate)}
        >
            <div className="my-5">
                <div className="flex flex-wrap w-full mb-5">
                    <Collapse in={true}>
                        <div>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DateTimePicker
                                    label={t('airdrops.snapshot_time')}
                                    value={snapshotDate}
                                    onChange={(e) =>
                                        setSnapshotDate(
                                            new Date(e.setSeconds(0)),
                                        )
                                    }
                                    ampm={!use24hrFormat}
                                    minDateTime={new Date()}
                                    renderInput={(params) => (
                                        <TextField {...params} />
                                    )}
                                />
                            </LocalizationProvider>
                        </div>
                    </Collapse>
                </div>
            </div>

            <Collapse in={true}>
                <div className="mb-5">
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={use24hrFormat}
                                    onChange={() => {
                                        setUse24hrFormat(!use24hrFormat)
                                    }}
                                />
                            }
                            label="Use 24-hour format"
                        />
                    </FormGroup>
                </div>
            </Collapse>

            <Collapse in={!dropStartDateValid(true, snapshotDate)}>
                <div className="mb-5">
                    <Alert severity="error">
                        {t('drops.the_start_date_must_be_in_the_future')}
                    </Alert>
                </div>
            </Collapse>
        </DropPaper>
    )
}
